import _ from 'lodash';
import reactiveCashflow from 'reactive-cashflow';
import CashflowUpdaterApi from '../../api/CashflowUpdaterApi';

const DEFAULT_TRACKING_CATEGORIES = [
  { label: 'אוכל בחוץ', icon: '🍕', style: 'primary' },
  { label: 'תחבורה ציבורית', icon: '🚌', style: 'primary' },
  { label: 'פארמה', icon: '💊', style: 'primary' },
  { label: 'רכב', icon: '🚗', style: 'primary' },
  { label: 'תרומה', icon: '💌', style: 'primary' },
  { label: 'תיירות', icon: '🏛', style: 'primary' },
  { label: 'פנאי', icon: '🎮', style: 'primary' },
  { label: 'ביגוד והנעלה', icon: '👕', style: 'primary' },
  { label: 'חיות מחמד', icon: '🐶', style: 'primary' },
];
const TRACKING_CATEGORY_ENVELOPE_TYPE = 'trackingCategory';

const state = {
  selectedTrackingCategory: null,
  amount: null,
};

const getters = {
  availableTrackingCategories: (state, getters, rootState, rootGetters) => {
    const presentedBudget = rootGetters['cashflowView/presentedBudget'];
    const displayedTrackingCategoryNames = _getTrackingCategoryNames(presentedBudget);
    return _.differenceWith(
      DEFAULT_TRACKING_CATEGORIES,
      displayedTrackingCategoryNames,
      (defaultCategory, displayed) => defaultCategory.label === displayed,
    );
  },
};

const actions = {
  async initialize({ commit, getters }) {
    commit('selectTrackingCategory', _.first(getters.availableTrackingCategories));
  },
  async selectTrackingCategory({ commit }, trackingCategory) {
    commit('selectTrackingCategory', trackingCategory);
  },
  async setAmount({ commit }, amount) {
    commit('setAmount', amount);
  },
  async reset({ commit }) {
    commit('setAmount', null);
    commit('selectTrackingCategory', null);
  },
  async showTrackingCategory({ commit, dispatch, state, rootGetters }) {
    const currentCashflow = rootGetters['cashflowView/presentedBudget'];
    const trackingCategoryId = await CashflowUpdaterApi.showTrackingCategory({
      name: state.selectedTrackingCategory.label,
      icon: state.selectedTrackingCategory.icon,
      amount: state.amount,
    });
    const newCashflow = reactiveCashflow.optimus.showTrackingCategory(
      currentCashflow,
      { amount: state.amount, icon: state.selectedTrackingCategory.icon, name: state.selectedTrackingCategory.label, trackingCategoryId },
    );
    await commit('cashflowView/setCashflowOptimistic', newCashflow, { root: true });
    await dispatch('cashflowView/resetBudgetTree', {}, { root: true });
  },
};

// mutations
const mutations = {
  selectTrackingCategory(state, trackingCategory) {
    state.selectedTrackingCategory = trackingCategory; // eslint-disable-line
  },
  setAmount(state, amount) {
    state.amount = amount; // eslint-disable-line
  },
};

function _getTrackingCategoryNames(budget) {
  return _.chain(budget.envelopes)
    .filter(e => e.type === TRACKING_CATEGORY_ENVELOPE_TYPE)
    .map(e => e.details.trackingCategory.name)
    .value();
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
